var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none",attrs:{"role":"menuitem"},on:{"click":_vm.createOffer}},[_vm._v(" "+_vm._s(_vm.account.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }